import { render } from "./filter-accordion.vue?vue&type=template&id=c442ccd0"
import script from "./filter-accordion.vue?vue&type=script&lang=js"
export * from "./filter-accordion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__